// getChatStartListSelectPath.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

/**
 * Select chat start list select path
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {String} query - Chat Start Users Query .
 * @param {String} category - Chat Start Users Discover Category.
 * @return {Array} The selected chat start list select path.
 */

const getChatStartListSelectPath = createSelector(
  state => state.getIn(['operations', 'swaggerOnlineFeed', 'search']),
  (state, query) => query,
  (state, query, category) => category,
  (swaggerOnlineFeed, query, category) => {
    if (query) return ['chatroom', 'user', 'query', query];

    return category === swaggerOnlineFeed
      ? ['home', 'users', category]
      : ['discover', category];
  }
);

export default getChatStartListSelectPath;
